// Helpers for the calendar's drag and drop.

type TIndexRange = { min: number; max: number };
export type TAxisRanges = { x: TIndexRange[]; y: TIndexRange[] };

export const hasMissingValue = (values: any[]) =>
    values.some((value) => value === null || value === undefined);
